export const SlideToMoveIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="68" viewBox="0 0 64 68" fill="none">
    <rect
      x="63.1262"
      y="0.873824"
      width="47.1935"
      height="62.2523"
      rx="11.8168"
      transform="rotate(90 63.1262 0.873824)"
      stroke="#B9BCCB"
      strokeWidth="1.74765"
    />
    <path
      d="M22.3988 53.5981L17.4746 46.8665C29.9742 45.7959 37.5978 45.3479 50.0974 44.2773V50.8567L48.3192 53.0499L22.3988 53.5981Z"
      fill="white"
    />
    <path
      d="M14.3609 25.2257L11.0524 22.545C10.8005 22.3409 10.7899 21.9602 11.0302 21.7424L14.1853 18.8828"
      stroke="#FFB4C9"
      strokeWidth="1.74765"
      strokeLinecap="round"
    />
    <path d="M20.7113 22.0254L12.6881 22.097" stroke="#FFB4C9" strokeWidth="1.74765" strokeLinecap="round" />
    <path
      d="M29.1277 11.8606L31.8988 8.62757C32.1099 8.38136 32.4908 8.38136 32.7018 8.62757L35.473 11.8606"
      stroke="#FFB4C9"
      strokeWidth="1.74765"
      strokeLinecap="round"
    />
    <path d="M32.1492 18.2969L32.2997 10.2747" stroke="#FFB4C9" strokeWidth="1.74765" strokeLinecap="round" />
    <path
      d="M50.7536 18.7469L54.0621 21.4276C54.314 21.6317 54.3246 22.0125 54.0843 22.2303L50.9292 25.0898"
      stroke="#FFB4C9"
      strokeWidth="1.74765"
      strokeLinecap="round"
    />
    <path d="M44.4033 21.9473L52.4265 21.8757" stroke="#FFB4C9" strokeWidth="1.74765" strokeLinecap="round" />
    <path
      d="M26.8144 45.158L23.5913 28.2329C23.4404 27.4407 23.6104 26.6211 24.0639 25.9543C24.5174 25.2875 25.2171 24.8282 26.0093 24.6773C26.8014 24.5265 27.6211 24.6965 28.2879 25.1499C28.9547 25.6034 29.414 26.3032 29.5649 27.0953L32.4087 42.0293"
      stroke="#848199"
      strokeWidth="1.74765"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.8503 41.5233L35.7347 26.3279C35.885 25.5357 36.344 24.8357 37.0105 24.3818C37.677 23.9279 38.4965 23.7574 39.2888 23.9078C40.081 24.0582 40.7811 24.5171 41.2349 25.1837C41.6888 25.8502 41.8593 26.6697 41.7089 27.4619L38.9265 42.1205"
      stroke="#848199"
      strokeWidth="1.74765"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.1329 42.1824C39.2833 41.3902 39.7422 40.6902 40.4088 40.2363C41.0753 39.7824 41.8948 39.6119 42.687 39.7623C43.4793 39.9127 44.1793 40.3716 44.6332 41.0381C45.087 41.7047 45.2575 42.5242 45.1072 43.3164L44.5402 46.3036"
      stroke="#848199"
      strokeWidth="1.74765"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.73 45.3086C44.8803 44.5164 45.3393 43.8163 46.0058 43.3625C46.6723 42.9086 47.4918 42.7381 48.2841 42.8885C49.0763 43.0389 49.7764 43.4978 50.2302 44.1643C50.6841 44.8309 50.8546 45.6504 50.7042 46.4426L49.0032 55.404C48.4017 58.5729 46.566 61.3731 43.8999 63.1886C41.2338 65.004 37.9557 65.686 34.7867 65.0845L30.8039 64.3285L31.2181 64.4071C29.2392 64.0318 27.3846 63.171 25.8206 61.9018C24.2566 60.6327 23.0324 58.995 22.2577 57.1358L21.9808 56.4642C21.5406 55.3924 20.0816 51.1769 17.6022 43.8153C17.3494 43.0649 17.3994 42.2455 17.7415 41.5313C18.0836 40.8172 18.6908 40.2647 19.4339 39.9913C20.2256 39.6997 21.0919 39.6811 21.8954 39.9383C22.6988 40.1954 23.3933 40.7137 23.8685 41.4107L26.2402 44.8938"
      stroke="#848199"
      strokeWidth="1.74765"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
